enum AdditionalQuestionInputType {
    Date,
    Select,
    TextArea,
    FileUpload,
}

export default AdditionalQuestionInputType;
